import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Chapter } from 'src/app/shared/models/capitulo';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';

@Component({
  selector: 'app-capitulos-presupuesto',
  templateUrl: './capitulos-presupuesto.component.html',
  styleUrls: ['./capitulos-presupuesto.component.css']
})
export class CapitulosPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private route: string;
  private method: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  listChapters: Chapter[] = [];
  filterDetails = new FormControl('0');
  descriptionFilter = new FormControl({ value: '', disabled: true });
  //descriptionSearch = new FormControl({ value: '', disabled: false });
  filterDictionary = new Map<string | null, string | null>();
  filterValue: string;
  dataSourceFilters = new MatTableDataSource<Chapter>;
  displayedColumns: string[] = ['reference', 'description'];
  selection = new SelectionModel<Chapter>(false, []);
  nroRegistros: number = 0;
  listLineItemsBudget: BudgetItem[] = [];
  @ViewChild(MatSort) sort: MatSort;
  classFlag: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public listPartidas: string[],
    public dialogCapitulosRef: MatDialogRef<CapitulosPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService
  ) { }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    //Inicio - Colocar valor por defecto 
    this.filterDetails.setValue('description');
    this.cleanFilter();
    //Fin - Colocar valor por defecto
    this.listLineItemsBudget = [];
    this.loadListChapterLineItems();
    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.listLineItemsBudget = data;
    });

    this.dataSourceFilters.filterPredicate = function (record, filter) {
      var map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (let [key, value] of map) {
        if (key as keyof Chapter === 'description') {
          isMatch = (record.description || '').trim().toLowerCase().indexOf(value as keyof Chapter) !== -1;
        } else if (key as keyof Chapter === 'reference') {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof Chapter) !== -1;
        } else if (key === "0") {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof Chapter) !== -1
            || (record.description || '').trim().toLowerCase().indexOf(value as keyof Chapter) !== -1
        } else if (value === '') {
          isMatch = true;
        };
        if (!isMatch) return false;
      }
      return isMatch;
    };
  }

  ngAfterViewInit() {
    this.dataSourceFilters.sort = this.sort;
  }

  cleanFilter() {
    this.descriptionFilter.setValue('');
    if (this.filterDetails.value === '0') {
      this.descriptionFilter.disable();
    } else {
      this.descriptionFilter.enable();
    }
    /* this.descriptionFilter.setValue('');
    this.descriptionSearch.setValue('');
    if (this.filterDetails.value === '0') {
      this.descriptionFilter.disable();
      this.descriptionSearch.enable();
    } else {
      this.descriptionFilter.enable();
      this.descriptionSearch.disable();
    } */
  }

  applyFilterDetails(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    this.filterDictionary.set(this.filterDetails.value, this.filterValue);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.dataSourceFilters.filter = jsonString;

    if (this.dataSourceFilters.paginator) {
      this.dataSourceFilters.paginator.firstPage();
    }
  }

  loadListChapterLineItems() {
    this.route = '/getChapters';
    this.method = 'GET';
    let data = {};
    this.listChapters = [];

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            for (let i = 0; i < response.data.length; i++) {
              let chapter: Chapter = {
                reference: response.data[i].chapterReference,
                description: response.data[i].descriptionChapter,
                idChapter: response.data[i].idChapter
              };
              this.listChapters.push(chapter);
            }
            this.dataSourceFilters.data = this.listChapters;
            this.nroRegistros = this.dataSourceFilters.data.length;
            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
      });
  }

  getSelectedRow() {
    return this.dataSourceFilters.data.filter((x) => this.selection.select(x));
  }

  aplicarCapituloPartidas() {
    for (let lineItemBudget of this.listLineItemsBudget) {
      for (let lineItemChapter of this.listPartidas) {
        if (lineItemChapter == lineItemBudget.reference) {
          lineItemBudget.chapterReference = this.selection.selected[0].reference;
          lineItemBudget.idChapterReference = this.selection.selected[0].idChapter;
          lineItemBudget.descriptionChapter = this.selection.selected[0].description;
          this.cachePartidasService.modify(lineItemBudget.idLineItem.toString(), lineItemBudget);
        }
      }
    }
    this.closeDialogCapitulosApu();
  }

  closeDialogCapitulosApu() {
    this.selection.clear();
    this.dialogCapitulosRef.close();
  }

}
